setTimeout(() => {
    (function() {
    const currentContainer = document.querySelector('.shadeshop-product-listing-wrapper');
    if (!currentContainer) return;

    // currentContainer.querySelector('.container').style.opacity = 0;
    const loader = document.createElement('div');
    loader.className = 'collection-loader';
    loader.innerHTML = `<div class="spinner"></div>`;
    currentContainer.style.position = 'relative';
    currentContainer.appendChild(loader); 
    setTimeout(() => {
        
        const mappings = {
            'custom-bestseller': {
                original: 'men-best-sellers',
                smart: 'men-bestseller-smart'
            },
            'custom-newarrival': {
                original: 'men-new-arrivals',
                smart: 'mens-new-arrival-smart'
            }
        };

        function getCurrentCollectionHandle() {
            const match = window.location.pathname.match(/\/collections\/([^/]+)/);
            return match ? match[1] : null;
        }

        if (document.readyState === 'loading') {
            document.addEventListener('readystatechange', () => {
                if (document.readyState === 'interactive') {
                    startFetch();
                }
            });
        } else {
            startFetch();
        }

        async function startFetch() {
            const currentHandle = getCurrentCollectionHandle();
            if (!currentHandle) return;

            let matchedMapping = null;
            for (const [bodyClass, mapping] of Object.entries(mappings)) {
                if (
                    document.body.classList.contains(bodyClass) &&
                    mapping.original === currentHandle
                ) {
                    matchedMapping = mapping;
                    break;
                }
            }

            if (!matchedMapping) {
                console.log('Skipping replacement — no mapping match for this collection.');
                 const loaderEl = document.querySelector('.collection-loader');
                if (loaderEl) loaderEl.remove(); 
                currentContainer.querySelector('.collection-product-list').classList.remove('opacity-0');
                return;
            }

            try {
                const response = await fetch(`/collections/${matchedMapping.smart}`);
                if (!response.ok) throw new Error(`HTTP error! Status: ${response.status}`);

                const html = await response.text();
                const parser = new DOMParser();
                const doc = parser.parseFromString(html, 'text/html');

                const newContainer = doc.querySelector('.collection-new-ui');
                if (newContainer) {
                    currentContainer.replaceWith(newContainer);
                    console.log(`Collection replaced with: ${matchedMapping.smart}`);
                }
                
            } catch (error) {
                console.error('Error fetching mapped collection:', error);
            } finally {
                const loaderEl = document.querySelector('.collection-loader');
                if (loaderEl) loaderEl.remove(); 
            }
        }
    }, 1000);
})();
}, 500);
